import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IPayer } from './payer'
import { ILineOfBusiness } from './lineOfBusiness'
import { ODataService } from 'common-services'

export interface IPlan extends IModelBase {
  Name: string
  PayerId: number
  PayerKey: string
  Payer: IPayer
  LineOfBusinessId: number
  LineOfBusinessKey: string
  LineOfBusiness: ILineOfBusiness
  AccountingPayerId?: number
  AccountingPayerName?: string
  PayerInvoiceTerm: number
  ClassName: string
  ModifiedByFullName: string
  ModifiedOn: Date
}

@Injectable()
export class PlanODataService extends ODataService<IPlan> {
  constructor(protected http: HttpClient, protected config: SmODataConfiguration) {
    super(http, config)
    this.typeName = 'Plans'
  }
}
